import gameApp from "@/index";
import { LitElement, html, css } from "lit";
import { customElement, property, state } from "lit/decorators.js";

@customElement("chat-box")
export class Chatbox extends LitElement {
  @property({ type: String }) inputValue: string = "";
  @property({ type: Boolean }) isVisible: boolean = false;
  @state() private isFocused: boolean = false;

  constructor() {
    super();
  }

  protected createRenderRoot() {
    return this; // Avoid shadow DOM if necessary
  }

  private _onInput(e: InputEvent) {
    const target = e.target as HTMLElement;
    // Update inputValue from the element's content without re-rendering it
    this.inputValue = target.textContent || "";
  }

  private _onFocus(e: FocusEvent) {
    this.isFocused = true;
  }

  private _onBlur(e: FocusEvent) {
    this.isFocused = false;
  }

  private _onBoldClick(e: MouseEvent) {
    e.preventDefault();
    document.execCommand("bold");
  }

  private _onItalicClick(e: MouseEvent) {
    e.preventDefault();
    document.execCommand("italic");
  }

  private _onUnderlineClick(e: MouseEvent) {
    e.preventDefault();
    document.execCommand("underline");
  }

  handleSubmit() {
    if (this.inputValue.trim()) {
      gameApp.wsClient.sendMessage(
        JSON.stringify({
          action: "chat",
          arguments: {
            message: this.inputValue,
          },
        })
      );
      this.inputValue = "";
      this.requestUpdate();
    }
  }

  render() {
    return html`
      <div
        class="navigation__chat is-active"
        style="display: flex; gap: 10px;"
      >
        <!-- Formatting toolbar on the left -->
        <div
          class="formatting-toolbar"
          style="display: flex; gap: 2px;"
        >
          <button class="btn" @mousedown="${this._onBoldClick}">B</button>
          <button class="btn" @mousedown="${this._onItalicClick}">I</button>
          <button class="btn" @mousedown="${this._onUnderlineClick}"
            >U</button
          >
        </div>

        <!-- Chat input wrapper with placeholder overlay -->
        <div
          class="chat-input-wrapper"
          style="position: relative; flex: 1; min-width: 0;"
        >
          <div
            class="navigation__chat_text"
            contenteditable="true"
            @input="${this._onInput}"
            @focus="${this._onFocus}"
            @blur="${this._onBlur}"
          ></div>
          ${!this.inputValue && !this.isFocused
            ? html`<span
                class="placeholder"
                >Type your message...</span
              >`
            : ""}
        </div>

        <!-- Send button -->
        <button class="btn" @click=${this.handleSubmit}>Send</button>
      </div>
    `;
  }
}
